import type {
  WithOptionalTestId,
  AlertSeverity,
  AcceptsChildren,
  BoxProps,
  ViewProps,
  TestId,
} from "@/theme"
import { SPACING, AlertCard, Box, View, Column } from "@/theme"

import React from "react"
import { StyleSheet } from "react-native"

export interface NoListItemProps extends WithOptionalTestId<ViewProps> {
  action?: React.JSX.Element
  severity?: AlertSeverity
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    marginHorizontal: "auto",
    width: "100%",
  },
  spacer: {
    marginVertical: SPACING.$1,
  },
})

export function ListEmptyContainer({ children }: AcceptsChildren) {
  return <Box p={"$4"}>{children}</Box>
}
/**
 * Standard view to display when a list is empty.
 */
export function NoListItems({
  action,
  children,
  id = "noListItems",
  message,
  severity = "info",
  style,
  ...rest
}: BoxProps & {
  action?: React.JSX.Element | null
  id?: TestId
  message: string
  severity?: AlertSeverity
}): React.JSX.Element {
  return (
    <Column id={id} space={"$4"} style={[styles.root, style]} {...rest}>
      <AlertCard
        bodyText={message}
        severity={severity}
        style={styles.spacer}
      />
      {Boolean(children) ? (
        <View style={styles.spacer}>{children}</View>
      ) : null}
      {action ? <View style={styles.spacer}>{action}</View> : null}
    </Column>
  )
}
